import { connect } from 'react-redux';
import ProductVariationList from '../components/ProductVariationList/ProductVariationList';
import { addToCart } from '../actions/cartActions';
import { requestProductVariations } from '../actions/productVariationActions';
import { getDisplayedData } from '../selectors/converterSelector';

const mapStateToProps = function(store) {
    return {
        loggedIn: store.user.loggedIn,
        hasInitialized: store.productVariation.hasInitialized,
        isLoading: store.productVariation.isLoading,
        list: getDisplayedData(
            store.productVariation.listDisplay,
            store.productVariation.list
        ),
        currencyFormat: store.cart.currencyFormat,
        currencyDisplayCode: store.cart.currencyDisplayCode,
        locale: store.cart.locale,
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {
        request: () => dispatch(requestProductVariations()),
        addToCart: (payload, callback) =>
            dispatch(addToCart(payload, callback)),
    };
};
const ConnectedProductVariationList = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductVariationList);

export default ConnectedProductVariationList;
